import * as React from "react"

interface PageHeaderData {
  title?: string
  description?: string
  icon?: React.ReactNode
  actions?: React.ReactNode
  stats?: {
    count: number
    label: string
    icon?: React.ReactNode
  }
}

interface PageHeaderContextType {
  headerData: PageHeaderData | null
  setHeaderData: (data: PageHeaderData | null) => void
}

const PageHeaderContext = React.createContext<PageHeaderContextType | undefined>(undefined)

export function PageHeaderProvider({ children }: { children: React.ReactNode }) {
  const [headerData, setHeaderData] = React.useState<PageHeaderData | null>(null)

  return (
    <PageHeaderContext.Provider value={{ headerData, setHeaderData }}>
      {children}
    </PageHeaderContext.Provider>
  )
}

export function usePageHeader() {
  const context = React.useContext(PageHeaderContext)
  if (!context) {
    throw new Error("usePageHeader must be used within PageHeaderProvider")
  }
  return context
}
